var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"brokerage",attrs:{"data-title":"佣金详情"}},[_c('section',[_c('div',{staticClass:"pay-rank"},[_c('router-view')],1)]),_c('footer',[_c('brokerageTabar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }